const strings = {
  writeClassificationToasts: {
    successUpsert: 'Call completed',
  },
} as const;

export default strings;
